import { Circle, CircleCheck, CirclePause, CirclePlay, CircleSlash } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { TaskStatus } from '@/types/api';

/**
 * The five columns, in board order, named from the point of view of the person
 * reading them.
 *
 * There is no "upcoming": future work stays in the desks' own scheduling and becomes a
 * card when it is actually actionable, which keeps every board free of things nobody
 * can act on.
 */
export const BOARD_COLUMNS: ReadonlyArray<{
  status: TaskStatus;
  label: string;
  /** Never colour alone — the shape is what makes the rail scannable. */
  icon: LucideIcon;
  colorVar: string;
  /** Same hue at low opacity, for the status pill's fill. */
  softVar: string;
  emptyMessage: string;
}> = [
  {
    status: 'pending',
    label: 'Pending',
    icon: Circle,
    colorVar: 'var(--color-status-pending)',
    softVar: 'color-mix(in oklch, var(--color-status-pending) 14%, transparent)',
    emptyMessage: 'Nothing waiting on you.',
  },
  {
    status: 'ongoing',
    label: 'Ongoing',
    icon: CirclePlay,
    colorVar: 'var(--color-status-ongoing)',
    softVar: 'color-mix(in oklch, var(--color-status-ongoing) 14%, transparent)',
    emptyMessage: 'Nothing in progress.',
  },
  {
    status: 'waiting',
    label: 'Waiting',
    icon: CirclePause,
    colorVar: 'var(--color-status-waiting)',
    softVar: 'color-mix(in oklch, var(--color-status-waiting) 14%, transparent)',
    emptyMessage: 'Nothing held up.',
  },
  {
    status: 'completed',
    label: 'Completed',
    icon: CircleCheck,
    colorVar: 'var(--color-status-completed)',
    softVar: 'color-mix(in oklch, var(--color-status-completed) 14%, transparent)',
    emptyMessage: 'Nothing finished yet.',
  },
  {
    status: 'cancelled',
    label: 'Cancelled',
    icon: CircleSlash,
    colorVar: 'var(--color-status-cancelled)',
    softVar: 'color-mix(in oklch, var(--color-status-cancelled) 16%, transparent)',
    emptyMessage: 'Nothing cancelled.',
  },
];

export const COLUMN_BY_STATUS = new Map(BOARD_COLUMNS.map((c) => [c.status, c]));
